import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {IndustryExpertiseResource} from '@/common/api/api-raw-types';

export default class IndustryExpertiseRepository {
    async loadExpertise(): Promise<HttpServiceResponse<IndustryExpertiseResource[]>> {
        return context.httpService.get(context.registry.entries.allIndustryExpertise());
    }
}
